// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Agjm","newExpiryDate":"styles_newExpiryDate__R3vgg","footer":"styles_footer__3h8kI"};